import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Stack,
  Button,
  InputLabel,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import * as yup from "yup";
import { Formik, Form } from "formik";
import { IconButton } from "@mui/material";
import { ReactComponent as CloseOutlined } from "../../assets/icons/close_icon.svg";
import axios from "axios";
import { doLogout } from "../../reducers/auth/auth.service";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

async function sendMessage({ name, email, message }) {
  const body = {
    fullName: name,
    email: email,
    message: message,
  };

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/contact-us`,
      body,
      config
    );
    return response.status;
  } catch (error) {
    console.log(error);
    return error;
  }
}

const validationSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .matches(/^[a-z A-Z]+$/, "Please enter valid full name")
    .max(100, "Maximum 100 characters are allowed")
    .required("Name is required"),
  email: yup
    .string()
    .trim()
    .max(100, "Maximum 100 characters are allowed")
    .email("Please enter a valid eamil")
    .required("Email is required"),
  message: yup
    .string()
    .trim()
    .max(200, "Maximum 100 characters are allowed")
    .required("Please enter a message"),
});

const initialValues = {
  name: "",
  email: "",
  message: "",
};

const HelpAndSupportDialog = ({ open, handleDialogClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          const trimmedValues = {};
          for (const key in values) {
            if (values.hasOwnProperty(key)) {
              if (typeof values[key] === "string") {
                trimmedValues[key] = values[key].trim();
              } else {
                trimmedValues[key] = values[key];
              }
            }
          }
          const response = await sendMessage(trimmedValues);
          if (response === 201) {
            resetForm();
            handleDialogClose();
          } else if (response === 401) {
            await dispatch(doLogout());
            navigate("/");
          }
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, resetForm }) => (
          <Form>
            <Dialog
              scroll="body"
              open={open}
              onClose={() => {
                resetForm();
                handleDialogClose();
              }}
              fullWidth
              disableScrollLock={false}
              slotProps={{
                paper: {
                  component: "form",
                  sx: {
                    px: { xs: "20px !important", sm: "56px !important" },
                    borderRadius: {
                      xs: "20px !important",
                      sm: "50px !important",
                    },
                  },
                },
              }}
            >
              <DialogTitle
                variant="h3"
                sx={{
                  textAlign: "center",
                  p: 0,
                  mt: "15px",
                  fontWeight: 700,
                }}
              >
                HELP & SUPPORT
              </DialogTitle>

              <Typography
                sx={{
                  color: "white",
                  textAlign: "center",
                  fontFamily: "secondaryFontFamily",
                  fontSize: "14px",
                  fontWeight: 300,
                  mb: "50px",
                }}
              >
                Fill in your details below, and our team will get back to you as
                soon as possible
              </Typography>

              <IconButton
                aria-label="close"
                onClick={() => {
                  resetForm();
                  handleDialogClose();
                }}
                sx={{
                  position: "absolute",
                  right: 20,
                  top: 20,
                  fontSize: "25px",
                  color: "#999999",
                }}
              >
                <CloseOutlined />
              </IconButton>
              <Stack direction={"column"} gap={{ md: 3, xs: 2 }}>
                <Box>
                  <InputLabel sx={{ color: "#1D1D3E", mb: "5px" }}>
                    Full name
                  </InputLabel>
                  <TextField
                    name="name"
                    placeholder="Enter full name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name && errors.name}
                    variant="outlined"
                    sx={{ width: "100%" }}
                  ></TextField>
                </Box>
                <Box>
                  <InputLabel sx={{ color: "#1D1D3E", mb: "5px" }}>
                    Email
                  </InputLabel>
                  <TextField
                    name="email"
                    placeholder="Enter email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                    variant="outlined"
                    sx={{ width: "100%" }}
                  ></TextField>
                </Box>
                <Box>
                  <InputLabel sx={{ color: "#1D1D3E", mb: "5px" }}>
                    Write message
                  </InputLabel>
                  <TextField
                    multiline
                    rows={4}
                    name="message"
                    placeholder="Enter here..."
                    value={values.message}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.message && Boolean(errors.message)}
                    helperText={touched.message && errors.message}
                    variant="outlined"
                    sx={{
                      width: "100%",
                      ".MuiOutlinedInput-root": {
                        borderRadius: "16px !important",
                      },
                    }}
                  ></TextField>
                </Box>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{
                    // mt: "50px",
                    mb: "30px",
                    width: "105px",
                    ml: "auto",
                    p: "10px 10px 6px 10px !important",
                  }}
                >
                  Submit
                </Button>
              </Stack>
            </Dialog>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default HelpAndSupportDialog;
